FiltrosActivosService.$inject = [];
export default function FiltrosActivosService() {
    var self = this;
    self.filtros = {};

    return {
        init: _init,
        setFiltros: _setFiltros,
        getFiltros: _getFiltros,
        limpiarFiltros: _limpiarFiltros,
        updateFilters: _updateFilters
    };

    function _setFiltros(rango) {
        self.filtros = rango;
    }

    function _getFiltros() {
        return self.filtros;
    }

    function _init() {
        self.filtros = {};
    }

    function _limpiarFiltros() {
        _init();
    }

    function _updateFilters(tabla) {
        if (tabla != 'tareas') {
            var keys = Object.keys(self.filtros);
            keys.forEach(function (key) {
                if (key == 'tecnico_id' || key == 'entidad_estudio_id' || key == 'reparador_id' || key == 'entidad_reparadora_id')
                    delete self.filtros[key];
            });
        }
    }
}